import React, { useEffect, useState } from "react"; 
import { useLocation } from "react-router-dom"; 
import {
  Typography,
  TextField,
  Button,
  Grid,
  Card,
  CardContent,
  CircularProgress,
  Container
} from "@mui/material";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../firebase"; // Adjust the path as necessary

const FullView = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const id = searchParams.get("uid"); // Get the document ID from the URL
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  // State for each editable field
  const [clinicId, setClinicId] = useState("");
  const [date, setDate] = useState("");
  const [day, setDay] = useState("");
  const [doctorId, setDoctorId] = useState("");
  const [status, setStatus] = useState("");
  const [timeStart, setTimeStart] = useState("");
  const [timeEnd, setTimeEnd] = useState("");
  const [availableSlots, setAvailableSlots] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      setError(""); 
      try {
        const docRef = doc(db, "timetable", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const docData = docSnap.data();
          setData(docData);
          // Initialize state fields with fetched data
          setClinicId(docData.clinicId || "");
          setDate(docData.date || "");
          setDay(docData.day || "");
          setDoctorId(docData.doctorId || "");
          setStatus(docData.status || "");
          setTimeStart(docData.timeStart || "");
          setTimeEnd(docData.timeEnd || "");
          setAvailableSlots(docData.availableSlots || "");
        } else {
          setError("No such document!");
        }
      } catch (error) {
        console.error("Error fetching document:", error);
        setError("Failed to fetch document.");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleUpdate = async () => {
    if (data) {
      // Ensure available slots is a valid number
      if (isNaN(availableSlots) || availableSlots < 0) {
        alert("Please enter a valid number for available slots.");
        return;
      }

      // Prepare the update data with all fields
      const updateData = {
        clinicId,
        date,
        day,
        doctorId,
        status,
        timeStart,
        timeEnd,
        availableSlots: parseInt(availableSlots), // Ensure this is a number
      };

      try {
        const docRef = doc(db, "timetable", id);
        await updateDoc(docRef, updateData);
        alert("Updated successfully!");
      } catch (error) {
        console.error("Error updating document:", error);
        alert("Failed to update document.");
      }
    }
  };

  if (loading) {
    return <CircularProgress />;
  }

  if (error) {
    return <Typography color="error">{error}</Typography>;
  }

  return (
    <Container maxWidth="sm" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
    <Card>
      <CardContent>
        <Typography variant="h5">Timetable</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Typography variant="subtitle1">ID: {data.id}</Typography>
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Clinic ID"
              value={clinicId}
              onChange={(e) => setClinicId(e.target.value)}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Date"
              value={date}
              onChange={(e) => setDate(e.target.value)}
              variant="outlined"
              fullWidth
              type="date"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Day"
              value={day}
              onChange={(e) => setDay(e.target.value)}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Doctor ID"
              value={doctorId}
              onChange={(e) => setDoctorId(e.target.value)}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Status"
              value={status}
              onChange={(e) => setStatus(e.target.value)}
              variant="outlined"
              fullWidth
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Time Start"
              value={timeStart}
              onChange={(e) => setTimeStart(e.target.value)}
              variant="outlined"
              fullWidth
              type="time"
            />
          </Grid>
          <Grid item xs={12}>
            <TextField
              label="Time End"
              value={timeEnd}
              onChange={(e) => setTimeEnd(e.target.value)}
              variant="outlined"
              fullWidth
              type="time"
            />
          </Grid>
          <Grid item xs={12}>
            <Typography variant="subtitle1">Available Slots: </Typography>
            <TextField
              type="number"
              value={availableSlots}
              onChange={(e) => setAvailableSlots(e.target.value)}
              label="Available Slots"
              variant="outlined"
              fullWidth
              inputProps={{ min: 0 }} 
            />
          </Grid>
          <Grid item xs={12}>
            <Button variant="contained" color="primary" onClick={handleUpdate}>
              Update
            </Button>
          </Grid>
        </Grid>
      </CardContent>
    </Card>

    </Container>
  );
};

export default FullView;
